let instance = null;

export const setLenis = (l) => {
  instance = l;
};

export const getLenis = () => instance;

export const scrollToTarget = (target, offset = -110) => {
  const l = getLenis();
  if (l) l.scrollTo(target, { offset });
  else if (typeof target === "number") window.scrollTo(0, target);
  else target?.scrollIntoView?.({ behavior: "smooth" });
};
